import { Sidebar } from "../Layout/Sidebar";
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { setLoading } from '../../services/reducers/homeSlice';
import restApi from '../../services/restApi';

import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";

const ArticleCategory = () => {
  const [data, setData] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [query, setQuery] = useState('');
  const deleteItem = async (id: number) => {
    if(confirm('آیا مطمئن هستید؟')){
      dispatch(setLoading(true));
      
      const res = await restApi(process.env.REACT_APP_BASE_URL + '/admin/articlecategory/' + id, true).delete({});
      
      if(res.code == 200){
        Swal.fire({
          title: 'موفق',
          text: 'دسته بندی مقاله با موفقیت حذف شد',
          icon: 'success',
          confirmButtonText: 'متوجه شدم'
        })
      } else {
        Swal.fire({
          title: 'ناموفق',
          text: res?.data,
          icon: 'error',
          confirmButtonText: 'متوجه شدم'
        })
      }
      
      dispatch(setLoading(false));
    }
  }
  
  const list = () => {
    const rows = [];
    
    data.filter((articlecategory:any) => articlecategory.title.toLowerCase().includes(query.toLowerCase())).map((articlecategory: any, index) => {
      console.log(articlecategory)
      rows.push(
        <tr className="">
          <td className="svgContainer">
            <i className="trash clickable" onClick={() => deleteItem(articlecategory.id)}></i>
            <i className="edit clickable" onClick={() => navigate('/articlecategory/edit/' + articlecategory.id)}></i>
          </td>
          <td className="">{articlecategory.description}</td>
          <td className="">{articlecategory.title}</td>
          <td>{++index}</td>
        </tr>
      )
    })
    
    return rows;
  };
  
  const fetchData = async () => {
    dispatch(setLoading(true));
    
    const res = await restApi(process.env.REACT_APP_BASE_URL + '/admin/articleCategory', true).get();
    console.log(res)
    if(res.code == 200){
      setData(res.data);
    }
    
    dispatch(setLoading(false));
  };
  
  useEffect(() => {
    fetchData();
  }, []);

  return(
    
    <>
      <body className="dashboardBody">
      <Sidebar />
      <main className="dashBoardMain">
        <h1 className="dashBoardTitle">دسته بندی   مقالات</h1>
        <div className="searchContainer">
          <span className="dashboardHeader clickable" onClick={() => navigate('/articlecategory/add')}>
            <p>افزودن دسته بندی  مقاله جدید</p>
            <i className="addPlus"></i>
          </span>
          <div className="dashboardseaechBox">
            <i className="dashMagnifierIcon"></i>
            <input className="dashSearchInput" placeholder="جستجو" onChange={(input: any) => setQuery(input.target.value)}></input>
          </div>
        </div>
        <table className="listTable">
          <thead>
            <tr className="firstTR">
              <th>عملیات</th>
              <th>توضیح</th>
              <th>عنوان</th>
              <th>ردیف</th>
            </tr>
          </thead>
          <tbody>
          {list()}
          </tbody>
        </table>
      </main>
      </body>
    </>
  )
}
export default ArticleCategory;